// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"513a47bf","293":"369c10e7","453":"ef213102","516":"ff204cca","917":"64000e7b","946":"9568af19"}[chunkId] + ".chunk.js";
};